import { render, staticRenderFns } from "./tipCom.vue?vue&type=template&id=71043ca6&scoped=true"
import script from "./tipCom.vue?vue&type=script&lang=js"
export * from "./tipCom.vue?vue&type=script&lang=js"
import style0 from "./tipCom.vue?vue&type=style&index=0&id=71043ca6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71043ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71043ca6')) {
      api.createRecord('71043ca6', component.options)
    } else {
      api.reload('71043ca6', component.options)
    }
    module.hot.accept("./tipCom.vue?vue&type=template&id=71043ca6&scoped=true", function () {
      api.rerender('71043ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/DeductionConfirmationForm/component/tipCom.vue"
export default component.exports